import { defineRecipe } from '@chakra-ui/react';
import { Borders, Colors, Space, BorderWidths } from '../../types';

export const dividerRecipe = defineRecipe({
  base: {
    opacity: '1',
    borderColor: Colors.BORDER_DEFAULT,
    borderStyle: 'solid',
  },
  variants: {
    orientation: {
      horizontal: { borderTopWidth: 0, borderBottomWidth: BorderWidths.SM, borderLeftWidth: 0, marginY: Space.SM },
      // A vertical divider has no natural cross-axis size, so without alignSelf 'stretch' it renders 0px tall
      // whenever its parent doesn't stretch its children (e.g. Center).
      vertical: {
        borderLeftWidth: BorderWidths.SM,
        borderBottomWidth: 0,
        marginX: Space.SM,
        alignSelf: 'stretch',
      },
    },
    variant: {
      sm: {},
      md: {},
      lg: {},
      dashed: { borderStyle: Borders.DASHED, borderBottomWidth: BorderWidths.XS },
      borderDefault: { borderColor: Colors.BORDER_DEFAULT },
    },
  },
  compoundVariants: [
    { variant: 'sm', orientation: 'horizontal', css: { borderBottomWidth: BorderWidths.XS, borderLeftWidth: 0 } },
    { variant: 'sm', orientation: 'vertical', css: { borderLeftWidth: BorderWidths.XS, borderBottomWidth: 0 } },
    { variant: 'md', orientation: 'horizontal', css: { borderBottomWidth: BorderWidths.SM, borderLeftWidth: 0 } },
    { variant: 'md', orientation: 'vertical', css: { borderLeftWidth: BorderWidths.SM, borderBottomWidth: 0 } },
    { variant: 'lg', orientation: 'horizontal', css: { borderBottomWidth: BorderWidths.LG, borderLeftWidth: 0 } },
    { variant: 'lg', orientation: 'vertical', css: { borderLeftWidth: BorderWidths.LG, borderBottomWidth: 0 } },
    {
      variant: 'borderDefault',
      orientation: 'horizontal',
      css: { borderBottomWidth: BorderWidths.SM, borderLeftWidth: 0 },
    },
    {
      variant: 'borderDefault',
      orientation: 'vertical',
      css: { borderLeftWidth: BorderWidths.SM, borderBottomWidth: 0 },
    },
  ],
  defaultVariants: {
    orientation: 'horizontal',
  },
});
